// data/dummyUAE.js

export const uaeInvoices = [
  {
    id: "UAE001",
    date: "2026-06-01",
    customer: "Dubai Retail LLC",
    amount: 1000,
    vat: 50,
    total: 1050,
  },
  {
    id: "UAE002",
    date: "2026-06-01",
    customer: "Abu Dhabi Digital Trading",
    amount: 2500,
    vat: 125,
    total: 2625,
  },
  {
    id: "UAE003",
    date: "2026-06-02",
    customer: "Sharjah Tech Solutions",
    amount: 1800,
    vat: 90,
    total: 1890,
  },
  {
    id: "UAE004",
    date: "2026-06-02",
    customer: "Ajman Marketing Hub",
    amount: 1200,
    vat: 60,
    total: 1260,
  },
  {
    id: "UAE005",
    date: "2026-06-03",
    customer: "Ras Al Khaimah Ventures",
    amount: 3000,
    vat: 150,
    total: 3150,
  },
  {
    id: "UAE006",
    date: "2026-06-03",
    customer: "Fujairah Cloud Systems",
    amount: 2200,
    vat: 110,
    total: 2310,
  },
  {
    id: "UAE007",
    date: "2026-06-04",
    customer: "Umm Al Quwain Digital",
    amount: 900,
    vat: 45,
    total: 945,
  },
  {
    id: "UAE008",
    date: "2026-06-04",
    customer: "Al Ain Business Group",
    amount: 1500,
    vat: 75,
    total: 1575,
  },
  {
    id: "UAE009",
    date: "2026-06-05",
    customer: "Jebel Ali Trading",
    amount: 2800,
    vat: 140,
    total: 2940,
  },
  {
    id: "UAE010",
    date: "2026-06-05",
    customer: "Dubai Marina Enterprises",
    amount: 3400,
    vat: 170,
    total: 3570,
  },
  {
    id: "UAE011",
    date: "2026-06-06",
    customer: "Business Bay Technologies",
    amount: 2100,
    vat: 105,
    total: 2205,
  },
  {
    id: "UAE012",
    date: "2026-06-06",
    customer: "Deira Trading Co",
    amount: 1700,
    vat: 85,
    total: 1785,
  },
  {
    id: "UAE013",
    date: "2026-06-07",
    customer: "Bur Dubai Solutions",
    amount: 2400,
    vat: 120,
    total: 2520,
  },
  {
    id: "UAE014",
    date: "2026-06-07",
    customer: "Dubai Silicon Oasis Ltd",
    amount: 3800,
    vat: 190,
    total: 3990,
  },
  {
    id: "UAE015",
    date: "2026-06-08",
    customer: "Internet City Innovations",
    amount: 4500,
    vat: 225,
    total: 4725,
  },
  {
    id: "UAE016",
    date: "2026-06-08",
    customer: "Media City Services",
    amount: 2600,
    vat: 130,
    total: 2730,
  },
  {
    id: "UAE017",
    date: "2026-06-09",
    customer: "Palm Jumeirah Holdings",
    amount: 5000,
    vat: 250,
    total: 5250,
  },
  {
    id: "UAE018",
    date: "2026-06-09",
    customer: "Al Barsha Consulting",
    amount: 1900,
    vat: 95,
    total: 1995,
  },
  {
    id: "UAE019",
    date: "2026-06-10",
    customer: "Dubai South Ventures",
    amount: 3200,
    vat: 160,
    total: 3360,
  },
  {
    id: "UAE020",
    date: "2026-06-10",
    customer: "Expo City Enterprises",
    amount: 4100,
    vat: 205,
    total: 4305,
  }
];

export const uaeReverseCharge = [
  {
    supplier: "Think5Whys Technologies India Pvt Ltd",
    service: "SaaS Subscription License",
    value: 100000,
    vat: 5000,
  },
  {
    supplier: "Think5Whys Technologies India Pvt Ltd",
    service: "PurpleDoor Analytics Engine",
    value: 75000,
    vat: 3750,
  },
  {
    supplier: "Think5Whys Technologies India Pvt Ltd",
    service: "LifeReplay Platform License",
    value: 50000,
    vat: 2500,
  },
  {
    supplier: "Think5Whys Technologies India Pvt Ltd",
    service: "AI Behaviour Engine",
    value: 125000,
    vat: 6250,
  },
  {
    supplier: "Think5Whys Technologies India Pvt Ltd",
    service: "Distributor Portal Access",
    value: 40000,
    vat: 2000,
  }
];